// extracted by mini-css-extract-plugin
module.exports = {"auth":"index_auth_202KL","container":"index_container_18d9v","googleSign":"index_googleSign_2z0jz","footerNav":"index_footerNav_1Lv7F"};